import * as React from 'react';
import { useState } from 'react';
import { Box, Button, CssBaseline, Grid, Paper, TextField, Typography, createTheme, ThemeProvider, IconButton, InputAdornment, Link, Snackbar, Alert } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { CopyRight } from '../common/util';
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

const defaultTheme = createTheme();

export default function Login(props) {
  const [showPassword, setShowPassword] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [resetSuccess, setResetSuccess] = useState(false);
  const [resetError, setResetError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    if (isLogin) {
      props.value.loginAs(data.get('email'), data.get('password'));
    } else {
      if (!email) {
        setResetError("Please enter your email address.");
        return;
      }
      try {
        const auth = getAuth();
        await sendPasswordResetEmail(auth, email);
        setResetSuccess(true);
        setResetError('');
        setIsLogin(true);
      } catch (error) {
        setResetError(error.message);
      }
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${props.value.image})`,
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <img src={require('../images/drLogo.PNG')} alt="" />
            <Typography component="h1" variant="h5">
              {props.value.role} {isLogin ? "Login" : "Reset Password"}
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {isLogin && (
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  autoComplete="current-password"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              {isLogin && 
                <Button type="submit" fullWidth variant="contained">
                  Login
                </Button>
              }
              <Grid container spacing={2} sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
                {!isLogin && (
                  <>
                  <Grid item xs={6}>
                    <Button type="submit" fullWidth variant="contained">
                      Reset Password
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      type="button"
                      fullWidth
                      variant="outlined"
                      onClick={() => setIsLogin(true)}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  </>
                )}
              </Grid>
              {isLogin && (
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                  <Link
                    component="button"
                    variant="body2"
                    onClick={() => setIsLogin(false)}
                  >
                    Forgot password?
                  </Link>
                </Grid>
              )}
              {CopyRight()}
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Snackbar for success message */}
      <Snackbar open={resetSuccess} autoHideDuration={4000} onClose={() => setResetSuccess(false)}>
        <Alert onClose={() => setResetSuccess(false)} severity="success">
          Password reset email sent!
        </Alert>
      </Snackbar>

      {/* Snackbar for error message */}
      <Snackbar open={Boolean(resetError)} autoHideDuration={4000} onClose={() => setResetError('')}>
        <Alert onClose={() => setResetError('')} severity="error">
          {resetError}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}
